import _ from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import { List, Message } from 'semantic-ui-react';
import { PapsContext } from '../../cnr/contexts/PapsContext';
import UiSaveButtons from '../../components/buttons/UiSaveButtons';
import Wrapper, { wrapperTypes } from '../../wrappers/Wrapper';
import { clientHasEvents } from './deleteClientPromise';
import { AppContext } from 'global/cnr/contexts/AppProvider';
import { ParentContext } from 'global/cnr/contexts/ParentContext';

/**
 * 
 * @returns a `DeleteClient` component
 * @description Presents the data paths that will be removed from the database. The `deleteClientPromise` function will remove the data. 
 */
const DeleteClient = () => {

  const parentContext = useContext(ParentContext);
  const { fn_cls } = parentContext ?? {}

  const appContext = useContext(AppContext);
  const { app_state } = appContext ?? {}
  const { mainFunctions } = app_state ?? {}

  // papsContext
  const papsContext = useContext(PapsContext);
  const { paps_state } = papsContext ?? {}
  const { pathViews, storageRootPath, settingsDocName } = paps_state ?? {}

  const [clientEventStatus, setClientEventStatus] = useState();

  const [updating, setUpdating] = useState()

  const { hasEvents } = clientEventStatus ? clientEventStatus : {}

  const handleDeleteClient = () => {
    setUpdating(true)
    fn_cls.deleteFullClientFromDatabase(pathViews, storageRootPath, mainFunctions).then(fnResult => {
      console.log('fnResult', fnResult);
      setUpdating(false)
    })
  }

  useEffect(() => {
    clientHasEvents(pathViews, setClientEventStatus)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const message = () => <Message
    negative={true}
    content={"Client has events - Delete not permitted. You must delete all the client's event prior to deleting the client"}
  />

  const listItem = (header, content) => <List.Item><List.Content>
    <List.Header >{header}</List.Header>
    <List.Description >{content}</List.Description>
  </List.Content>
  </List.Item>

  const content = () => {
    const viewItemKeys = [
      'profiles'
    ]
    const items = []
    Object.keys(pathViews).forEach(key => (
      items.push(listItem(key, pathViews[key]))
    ))
    viewItemKeys.forEach(key => (
      items.push(listItem(key, '.../' + key))
    ))
    // storageRootPath
    items.push(listItem(_.startCase('storage'), storageRootPath))
    items.push(listItem(_.startCase('settings'), settingsDocName))
    return <List relaxed divided inverted>
      {items}
    </List>
  }

  const footer = () => {
    if (hasEvents) {
      return message()
    } else {
      return <UiSaveButtons save={{ oc: handleDeleteClient, caption: 'Delete Client' }} />
    }
  }

  const wrapper = () => <Wrapper
    content={content()}
    footer={footer()}
    wrapperType={wrapperTypes.paddedFooter}
    updatingCaption={'Delete Client?'}
    updating={updating}
  />

  return wrapper()
}

export default DeleteClient